const WORDS = ["Meleg étkezés", "Haszonélvezeti jog", "Ügyvédi jelenlét", "Teljes diszkréció", "Egész Magyarország"];

export const Marquee = () => (
  <div className="bg-navy text-ivory overflow-hidden py-5" aria-hidden="true" data-testid="badge-marquee">
    <div className="mq disp uppercase text-2xl md:text-3xl gap-12 pr-12">
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className="flex items-center gap-12">
          <span>{w}</span>
          <span className="text-gold">✦</span>
        </span>
      ))}
    </div>
  </div>
);
